import { generateUUID } from '@comp-sys/shared';

const DEVICE_ID_KEY = 'device_id';

/**
 * 获取当前设备的唯一标识符
 * 如果不存在，则生成一个新的 UUID 并存储
 */
export function getDeviceId(): string {
  if (typeof window === 'undefined') {
    return 'server';
  }

  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = generateUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
}

/**
 * 检测当前平台是否支持 emoji 旗帜显示
 * Windows 不支持区域旗帜 emoji (如 🇨🇳, 🇺🇸 等)
 */
export function supportsEmojiFlags(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  // Windows 不支持 emoji 旗帜
  const platform = navigator.platform?.toLowerCase() || '';
  if (platform.includes('win')) {
    return false;
  }
  // 此外可以通过 CSS @supports 检测字体是否支持特定字符
  // 但 navigator.platform 已经足够准确
  return true;
}
